/**
 * Pure helper for composing meeting URLs.
 * No React imports, no window.open - returns URL for caller to open.
 */

import {handleMeetingLink} from "../../../utils/meeting";

export interface JoinResultForLaunch {
  token: string;
  roomId: string;
  videoPlatform: string;
  customRoomLink: string | null;
  dailyCoUrl: string | null;
}

export interface LaunchMeetingUser {
  firstName: string;
  lastName: string;
}

export interface LaunchMeetingEvent {
  name: string;
}

export interface LaunchMeetingParams {
  joinResult: JoinResultForLaunch;
  user: LaunchMeetingUser;
  event: LaunchMeetingEvent;
  role: "host" | "guest";
}

export interface LaunchMeetingResult {
  url: string;
  target: "_blank";
}

export function launchMeeting({
  joinResult,
  user,
  event,
  role,
}: LaunchMeetingParams): LaunchMeetingResult {
  const platform = joinResult.videoPlatform.toLowerCase();

  if (platform === "custom" && joinResult.customRoomLink) {
    return {
      url: joinResult.customRoomLink,
      target: "_blank",
    };
  }

  if (platform === "custom") {
    return {
      url: `//${joinResult.roomId}`,
      target: "_blank",
    };
  }

  if (platform === "dailyco") {
    return {
      url: `${joinResult.dailyCoUrl}?t=${joinResult.token}`,
      target: "_blank",
    };
  }

  if (platform === "zoom") {
    return {
      url: joinResult.roomId ?? "",
      target: "_blank",
    };
  }

  if (platform === "googlemeet") {
    return {
      url: joinResult.roomId ?? "",
      target: "_blank",
    };
  }

  const genericUrl = handleMeetingLink(role, {
    token: joinResult.token,
    roomId: joinResult.roomId,
    firstName: user.firstName,
    lastName: user.lastName,
    meetingTitle: event.name,
  });

  return {
    url: genericUrl,
    target: "_blank",
  };
}
